export default __webpack_public_path__ + "static/media/eyeOpen.08b3f47e.svg";